import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Accordion/accordion';
export const AccordionExpandedContentBody = ({ children = null }) => React.createElement("div", { className: css(styles.accordionExpandedContentBody) }, children);
AccordionExpandedContentBody.displayName = 'AccordionExpandedContentBody';
//# sourceMappingURL=AccordionExpandedContentBody.js.map